import { DeviceType, deviceTypesWithOwner } from '@ixicare/resources';

export const MAX_HOURS_NOT_SEEN = 25; // Default to 4 hours, if at the end of the installationday, the device has not been seen for 4 hours, it is considered missing.

export const LAST_SEEN_THRESHOLD = new Date(Date.now() - MAX_HOURS_NOT_SEEN * 60 * 60 * 1000);

export const BEACON_MAX_DAYS_NOT_SEEN = 14; // Beacons report infrequently, so allow a longer window before flagging missing.

export const BEACON_LAST_SEEN_THRESHOLD = new Date(Date.now() - BEACON_MAX_DAYS_NOT_SEEN * 24 * 60 * 60 * 1000);

export const INSTALL_BATT_THRESHOLD = 66; // 66% battery level is considered low for a fresh installation

export const MIN_SW_VERSION_PER_DEVICE_TYPE = {
  WATCHERR: { swVersion: '1.9.1' },
  IXI_PRO: { swVersion: '1.9.1' },
  WALL_MOUNTED_DISTRESS_BUTTON: { swVersion: '2.2.4' },
  WRISTBAND_DISTRESS_BUTTON: { swVersion: '2.2.4' },
  IXI_LITE: { swVersion: '2.2.4' },
  IXI_TOUCH: { swVersion: '2.2.4' },
  IXI_BLACK: { swVersion: '2.2.4' },
  GATEWAY: {
    mcuVersion: '1.7.0',
    bleVersion: '1.7.0',
  },
  BEACON: { swVersion: '1.0.0' },
};

export const WEARABLE_TYPES = deviceTypesWithOwner;

export const WRISTWATCH_TYPES = [DeviceType.WATCHERR, DeviceType.IXI_PRO];

export const CALLABLE_TYPES = [DeviceType.WATCHERR, DeviceType.IXI_PRO, DeviceType.EVIEW, DeviceType.TWIG];

export const WRISTBAND_TYPES = [
  DeviceType.WRISTBAND_DISTRESS_BUTTON,
  DeviceType.IXI_LITE,
  DeviceType.IXI_TOUCH,
  DeviceType.IXI_BLACK,
];

export const WEARABLE_OR_BUTTON_TYPES = [DeviceType.WALL_MOUNTED_DISTRESS_BUTTON, ...WEARABLE_TYPES];
